import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { PriorityHigh } from '@mui/icons-material';
import { Body3, Body1 } from '../../../themes/typography';
import Shmooz from '../../../assets/images/Shmooz-Logo.png';
import '../../../styles/components/LoginForm.css';

export default function InvalidLink({ onClick = () => {} }) {
    return (
        <React.Fragment>
            <div className="main-login-email-collect-container">
                <div className="invalid-link-logo-container">
                    <img src={Shmooz} alt="Shmooz" />
                </div>

                <div className="main-login-form">
                    <div className="invalid-email-link-container slide-transition slide-active">
                        <div className="main-switchable-login-form">
                            <div className="sent-email-success-container">
                                <div className="invalid-email-icon-container">
                                    <PriorityHigh color="error" sx={{ fontSize: '2rem' }} />
                                </div>
                                <Body1 color="var(--error-main-color)" fontWeight={500}>
                                    Link Invalid or Expired
                                </Body1>
                                <div className="sent-email-text-container">
                                    <Body3 fontWeight={400}>
                                        The magic link you clicked is no longer valid.
                                    </Body3>
                                    <Body3 fontWeight={400}>
                                        Please try logging in again or request a new magic link.
                                    </Body3>
                                </div>
                            </div>

                            <div className="login-methods-container">
                                <div className="login-methods-action-buttons">
                                    <Button
                                        variant="main"
                                        disableRipple
                                        fullWidth
                                        onClick={onClick}
                                    >
                                        Back to Login
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="login-terms-agree-container">
                    <Body3>
                        By signing in you accept Shmooz {''}
                        <span className="terms">
                            <Link>Terms of Service</Link>
                        </span>{' '}
                        and
                        <span className="terms">
                            {' '}
                            {''}
                            <Link>Privacy Policy</Link>
                        </span>
                    </Body3>
                </div>
            </div>
        </React.Fragment>
    );
}
